import algoliasearch from 'algoliasearch';

export const algoliaClient = algoliasearch(
  'ISOJ21OIEK',
  '5ce3a86240b219c3d6163a6c3ad19008'
);

export const songIndex = algoliaClient.initIndex(`song`);
